import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getWarrantyCardAvailableColumns } from './api';

export const path = '/warranty-card/list';

const PageWarrantyCard: React.FC = (props) => {
  const WarrantyCard = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getWarrantyCardAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <WarrantyCard {...props} />;
};

export default PageWarrantyCard;
